import axiosInstance from "./AxiosInstanceMain";

export const getResaleInventoryApi = async (params = {}) => {
  const response = await axiosInstance.get("/resale-inventory", { params });
  return response.data;
};

export const getResaleInventoryByIdApi = async (id) => {
  const response = await axiosInstance.get(`/resale-inventory/${id}`);
  return response.data;
};

export const createResaleInventoryApi = async (data) => {
  const response = await axiosInstance.post("/resale-inventory", data);
  return response.data;
};

export const updateResaleInventoryApi = async (id, data) => {
  const response = await axiosInstance.put(`/resale-inventory/${id}`, data);
  return response.data;
};

export const addResaleInventoryLogApi = async (id, note) => {
  const response = await axiosInstance.post(`/resale-inventory/${id}/log`, { note });
  return response.data;
};

export const updateResaleInventoryStatusApi = async (id, sale_status) => {
  const response = await axiosInstance.patch(`/resale-inventory/${id}/status`, { sale_status });
  return response.data;
};

export const deleteResaleInventoryApi = async (id) => {
  const response = await axiosInstance.delete(`/resale-inventory/${id}`);
  return response.data;
};

export const uploadResaleInventoryMediaApi = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosInstance.post("/resale-inventory/upload-media", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
